import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import ReactHTMLTableToExcel from "react-html-table-to-excel"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const panel_status_enum = {
      0: "تراکنش با موفقيت انجام شد",
      11: "شماره کارت نامعتبر است",
      12: "موجودی کافي نيست ",
      13: "رمز نادرست است ",
      14: "تعداد دفعات وارد کردن رمز بيش از حد مجاز است ",
      15: "کارت نامعتبر است",
      16: "دفعات برداشت وجه بيش از حد مجاز است",
      17: "کاربر از انجام تراکنش منصرف شده است ",
      18: "تاريخ انقضای کارت گذشته است ",
      19: "مبلغ برداشت وجه بيش از حد مجاز است ",
      111: "صادر کننده کارت نامعتبر است",
      112: "خطای سوييچ صادر کننده کارت ",
      113: "پاسخي از صادر کننده کارت دريافت نشد ",
      114: "دارنده کارت مجاز به انجام اين تراکنش نيست ",
      21: "پذيرنده نامعتبر است ",
      23: "خطای امنيتي رخ داده است ",
      24: "اطالعات کاربری پذيرنده نامعتبر است",
      25: "مبلغ نامعتبر است ",
      31: "پاسخ نامعتبر است ",
      32: "فرمت اطالعات وارد شده صحيح نمي باشد ",
      33: "حساب نامعتبراست",
      34: "خطای سيستمي ",
      35: "تاريخ نامعتبر است ",
      41: "شماره درخواست تکراری است",
      42: "تراکنش Sale يافت نشد ",
      43: "قبال درخواست Verify داده شده است",
      44: "درخواست Verfiy يافت نشد ",
      45: "تراکنش Settle شده است ",
      46: "تراکنش Settle نشده است ",
      47: "تراکنش Settle يافت نشد ",
      48: "تراکنش Reverse شده است ",
      412: "شناسه قبض نادرست است",
      413: "شناسه پرداخت نادرست است ",
      414: "سازمان صادر کننده قبض نامعتبر است",
      415: "زمان جلسه کاری به پايان رسيده است ",
      416: "خطا در ثبت اطالعات",
      417: "شناسه پرداخت کننده نامعتبر است ",
      418: "اشکال در تعريف اطالعات مشتری ",
      419: "تعداد دفعات ورود اطالعات از حد مجاز گذشته است ",
      421: "IPنامعتبر است",
}

class ChangeRefundUserPayed extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,

                  RefundUser: null,
                  orderBy: "pey_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",

                  refundUserMaxDate: "",
                  refundUserMinDate: "",
                  refundUserMaxAmount: "",
                  refundUserMinAmount: "",

                  refundPayMaxDate: "",
                  refundPayMinDate: "",
                  requestIdFilter: "",
            }
      }

      setSelectedDayMax = (event) => {
            this.setState({ refundUserMaxDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMax = (event) => {
            this.setState({ refundUserMaxDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayMin = (event) => {
            this.setState({ refundUserMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMin = (event) => {
            this.setState({ refundUserMinDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedPayDayMax = (event) => {
            this.setState({ refundPayMaxDate: event }, () => {
                  this.filterList()
            })
      }

      clearPayDeyMax = (event) => {
            this.setState({ refundPayMaxDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedPayDayMin = (event) => {
            this.setState({ refundPayMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearPayDeyMin = (event) => {
            this.setState({ refundPayMinDate: "" }, () => {
                  this.filterList()
            })
      }

      handleChangeMaxAmount = (event) => {
            this.setState({ refundUserMaxAmount: event }, () => {
                  this.filterList()
            })
      }

      handleChangeMinAmount = (event) => {
            this.setState({ refundUserMinAmount: event }, () => {
                  this.filterList()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeFilterRequestId = (event) => {
            this.setState({ requestIdFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})

                              var State = [{ value: "0", label: "همه  کاربران" }]
                              var State2 = [{ value: "0", label: "همه رشته ها" }]
                              var State3 = [{ value: "0", label: "همه وضعیت ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    var toFind = arr.data[k].user_id
                                    var filtered = State.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State.push({
                                                value: arr.data[k].user_id,
                                                label: arr.data[k].user_name + " " + arr.data[k].user_family + " " + arr.data[k].user_mobile,
                                          })
                                    }

                                    toFind = arr.data[k].fieldinsurance_id
                                    filtered = State2.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State2.push({ value: arr.data[k].fieldinsurance_id, label: arr.data[k].request_fieldinsurance_fa })
                                    }

                                    toFind = arr.data[k].request_last_state_id
                                    filtered = State3.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State3.push({ value: arr.data[k].request_last_state_id, label: arr.data[k].request_last_state_name })
                                    }
                              }
                              self.setState({ optionSelectUser: State, selectedSelectUser: State[0] })
                              self.setState({ optionFieldInsurance: State2, selectedFieldInsurance: State2[0] })
                              self.setState({ optionStatusRequest: State3, selectedStatusRequest: State3[0] })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_userokpay")
            fd.append("report_mode", "all")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/reportuserpay`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleFieldInsurance = (selectedFieldInsurance) => {
            this.setState({ selectedFieldInsurance: selectedFieldInsurance }, () => {
                  this.filterList()
            })
      }

      handleStatusRequest = (selectedStatusRequest) => {
            this.setState({ selectedStatusRequest: selectedStatusRequest }, () => {
                  this.filterList()
            })
      }

      handleSelectUser = (selectedSelectUser) => {
            this.setState({ selectedSelectUser: selectedSelectUser }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  refundUserMaxAmount,
                  requestIdFilter,
                  refundUserMinAmount,
                  requestinfos,
                  selectedFieldInsurance,
                  selectedStatusRequest,
                  selectedSelectUser,
                  refundUserMinDate,
                  refundUserMaxDate,
                  refundPayMinDate,
                  refundPayMaxDate,
            } = this.state

            var timeStampMax = parseInt(
                  Moment(JDate.toGregorian(refundUserMaxDate.year, refundUserMaxDate.month, refundUserMaxDate.day)).format("x"),
                  0
            )
            var timeStampMin = parseInt(
                  Moment(JDate.toGregorian(refundUserMinDate.year, refundUserMinDate.month, refundUserMinDate.day)).format("x"),
                  0
            )
            var timeStampPayMax = parseInt(
                  Moment(JDate.toGregorian(refundPayMaxDate.year, refundPayMaxDate.month, refundPayMaxDate.day)).format("x"),
                  0
            )
            var timeStampPayMin = parseInt(
                  Moment(JDate.toGregorian(refundPayMinDate.year, refundPayMinDate.month, refundPayMinDate.day)).format("x"),
                  0
            )

            var i, temparray, temparray2, staterequest_last_timestamp, pey_backdate
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  staterequest_last_timestamp = parseInt(Moment(temparray[i].staterequest_last_timestamp, "YYYY-M-D HH:mm:ss").format("x"))
                  pey_backdate = parseInt(Moment(temparray[i].pey_backdate, "YYYY-M-D HH:mm:ss").format("x"))

                  if (
                        (temparray[i].fieldinsurance_id === selectedFieldInsurance.value || selectedFieldInsurance.value === "0") &&
                        (temparray[i].request_last_state_id === selectedStatusRequest.value || selectedStatusRequest.value === "0") &&
                        (temparray[i].user_id === selectedSelectUser.value || selectedSelectUser.value === "0") &&
                        (staterequest_last_timestamp > timeStampMin || !timeStampMin) &&
                        (staterequest_last_timestamp < timeStampMax || !timeStampMax) &&
                        (pey_backdate > timeStampPayMin || !timeStampPayMin) &&
                        (pey_backdate < timeStampPayMax || !timeStampPayMax) &&
                        ((requestIdFilter !== "" && temparray[i].request_id === requestIdFilter) || requestIdFilter === "") &&
                        (parseInt(refundUserMinAmount) <= parseInt(temparray[i].pey_amount) || refundUserMinAmount === "") &&
                        (parseInt(refundUserMaxAmount) > parseInt(temparray[i].pey_amount) || refundUserMaxAmount === "")
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getFinancialDocPaing()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing()
            })
      }

      renderCustomInputMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ درخواست"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMaxDate.year
                              ? this.state.refundUserMaxDate.year + "/" + this.state.refundUserMaxDate.month + "/" + this.state.refundUserMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ درخواست"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMinDate.year
                              ? this.state.refundUserMinDate.year + "/" + this.state.refundUserMinDate.month + "/" + this.state.refundUserMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پرداخت"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMaxDate.year
                              ? this.state.refundPayMaxDate.year + "/" + this.state.refundPayMaxDate.month + "/" + this.state.refundPayMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پرداخت"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMinDate.year
                              ? this.state.refundPayMinDate.year + "/" + this.state.refundPayMinDate.month + "/" + this.state.refundPayMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  requestIdFilter,
                  refundUserMaxDate,
                  refundUserMinDate,
                  refundPayMaxDate,
                  refundPayMinDate,
                  refundUserMaxAmount,
                  refundUserMinAmount,
                  optionFieldInsurance,
                  selectedFieldInsurance,
                  optionStatusRequest,
                  selectedStatusRequest,
                  optionSelectUser,
                  selectedSelectUser,
                  RefundUser,
                  snackMode,
                  snackstr,
                  showSnack,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMin} // render a custom input
                                                                                    value={refundUserMinDate}
                                                                                    onChange={this.setSelectedDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست  تا"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMax} // render a custom input
                                                                                    value={refundUserMaxDate}
                                                                                    onChange={this.setSelectedDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMin} // render a custom input
                                                                                    value={refundPayMinDate}
                                                                                    onChange={this.setSelectedPayDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت  تا"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMax} // render a custom input
                                                                                    value={refundPayMaxDate}
                                                                                    onChange={this.setSelectedPayDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداقل مبلغ"
                                                                        handleInputt={this.handleChangeMinAmount}
                                                                        value={refundUserMinAmount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداکثر مبلغ"
                                                                        handleInputt={this.handleChangeMaxAmount}
                                                                        value={refundUserMaxAmount}
                                                                  />
                                                            </Grid>
                                                            <Grid sm={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره سفارش"
                                                                        value={requestIdFilter}
                                                                        handleInputt={this.handleChangeFilterRequestId}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">نوع کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={" نام کاربر"}
                                                                              value={selectedSelectUser}
                                                                              onChange={this.handleSelectUser}
                                                                              options={optionSelectUser}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کاربر"}
                                                                              value={selectedFieldInsurance}
                                                                              onChange={this.handleFieldInsurance}
                                                                              options={optionFieldInsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">وضعیت درخواست</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"وضعیت درخواست"}
                                                                              value={selectedStatusRequest}
                                                                              onChange={this.handleStatusRequest}
                                                                              options={optionStatusRequest}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"pey_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "pey_id" ? order : false}
                                                                              >
                                                                                    {"آیدی سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "pey_id"}
                                                                                          direction={orderBy === "pey_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("pey_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"user_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"آی دی کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_id"}
                                                                                          direction={orderBy === "user_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"user_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_name"}
                                                                                          direction={orderBy === "user_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"pey_amount"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"مبلغ"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "pey_amount"}
                                                                                          direction={orderBy === "pey_amount" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("pey_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"pey_backdate"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ پرداخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "pey_backdate"}
                                                                                          direction={orderBy === "pey_backdate" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("pey_backdate")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"pey_refrenceid"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کد رهگیری"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "pey_refrenceid"}
                                                                                          direction={orderBy === "pey_refrenceid" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("pey_refrenceid")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"pey_mode"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نوع پرداخت "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "pey_mode"}
                                                                                          direction={orderBy === "pey_mode" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("pey_mode")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"request_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"وضعیت پرداخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"request_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"شماره درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_fieldinsurance_fa"}
                                                                                          direction={
                                                                                                orderBy === "request_fieldinsurance_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_last_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"وضعیت درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_last_state_name"}
                                                                                          direction={
                                                                                                orderBy === "request_last_state_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_last_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"staterequest_last_timestamp"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ آخرین وضعیت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "staterequest_last_timestamp"}
                                                                                          direction={
                                                                                                orderBy === "staterequest_last_timestamp"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("staterequest_last_timestamp")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["pey_id"]}
                                                                                          value={row}
                                                                                          onClick={() => {}}
                                                                                    >
                                                                                          <TableCell key={"pey_id"} align={"center"}>
                                                                                                {row["pey_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_id"} align={"center"}>
                                                                                                {row["user_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_name"} align={"center"}>
                                                                                                {row["user_name"] + " " + row["user_family"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_mobile"} align={"center"}>
                                                                                                {row["user_mobile"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"pey_amount"} align={"center"}>
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["pey_amount"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell key={"pey_backdate"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row["pey_backdate"],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["pey_backdate"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>

                                                                                          <TableCell key={"pey_refrenceid"} align={"center"}>
                                                                                                {row["pey_refrenceid"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"pey_mode"} align={"center"}>
                                                                                                {row["pey_mode"] === "pey"
                                                                                                      ? "پرداخت اصلی"
                                                                                                      : "کسری واریزی"}
                                                                                          </TableCell>
                                                                                          <TableCell key={"pey_mode"} align={"center"}>
                                                                                                {panel_status_enum[row["pey_backcode"]]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"request_id"} align={"center"}>
                                                                                                {row["request_id"]}
                                                                                          </TableCell>
                                                                                          <TableCell
                                                                                                key={"request_fieldinsurance_fa"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["request_fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"company_name"} align={"center"}>
                                                                                                {row["company_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"request_last_state_name"} align={"center"}>
                                                                                                {row["request_last_state_name"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"pey_amount"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row[
                                                                                                                              "staterequest_last_timestamp"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["staterequest_last_timestamp"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRefundUserPayed)
